import script from "./BankEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./BankEdit.vue?vue&type=script&setup=true&lang=js"

import "./BankEdit.vue?vue&type=style&index=0&id=1d762913&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d762913"]])

export default __exports__